import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Sync} from '@client/sync'
import {Button} from '@components/common/button/button'
import {Loading} from '@components/common/loading/loading'
import {Popup} from '@components/common/popup/popup'
import {useFormPopup} from './use-form-popup'

const TwForm = tw.div`
  flex
  flex-col
  gap-16
  pt-16
  mx-64
`

const TwFormRow = tw.div`
  flex
  flex-row
  items-baseline
  gap-8
`

const TwFormLabel = tw.div`
  leading-main
  text-12
  text-secondary-old
  flex-1
`

const TwFormInputContainer = tw.div`
  flex-1
  flex
  flex-col
  gap-4
`

const TwFormInput = tw.input`
  flex
  items-center
  h-32
  pl-8
  pr-8
  border
  border-solid
  outline-none
  border-main-old
  text-main-old
  focus:bg-input-old
  focus-within:border-action-default
  rounded-4
  bg-input-old
  text-14
  mb-0
  w-220
  grow-0
  shrink-0
  basis-auto
`

const TwFormInputError = tw.span`
  grow-0
  shrink-0
  basis-auto
  text-error-old
`

const TwCenter = tw.div`
  flex
  justify-center
  text-third-old
  mt-8
`

export const FormPopup = observer(() => {
  const {formData, formErrors, isWait, close, submit, updateForm} =
    useFormPopup()

  const footer = isWait ? (
    <TwCenter>
      <Loading />
    </TwCenter>
  ) : (
    <Button onClick={submit}>{Lang.msg.profilePage.changeEmail}</Button>
  )

  return (
    <Popup
      width={584}
      autoHeight={true}
      close={close}
      title={Lang.msg.profilePage.emailChange}
      footer={footer}
    >
      <TwForm>
        <TwFormRow>
          <TwFormLabel>
            {Lang.msg.profilePage.emailChangeYourCurrentEmail}{' '}
            {Sync.getCurrentUser().email}
          </TwFormLabel>
        </TwFormRow>
        <TwFormRow>
          <TwFormLabel>
            {Lang.msg.profilePage.emailChangeEnterNewEmail}
          </TwFormLabel>
          <TwFormInputContainer>
            <TwFormInput
              type="input"
              value={formData.newEmail}
              disabled={isWait}
              placeholder={Lang.msg.profilePage.emailChangeEmailPlaceholder}
              onChange={e => updateForm({newEmail: e.target.value})}
            />
            {formErrors.newEmail?.map(error => (
              <TwFormInputError key={error}>
                {Lang.tryLocalize(error)}
              </TwFormInputError>
            ))}
          </TwFormInputContainer>
        </TwFormRow>
        <TwFormRow>
          <TwFormLabel>
            {Lang.msg.profilePage.emailChangeEnterCurrentPassword}
          </TwFormLabel>
          <TwFormInputContainer>
            <TwFormInput
              type="password"
              disabled={isWait}
              placeholder={Lang.msg.profilePage.emailChangePasswordPlaceholder}
              value={formData.currentPassword}
              onChange={e => updateForm({currentPassword: e.target.value})}
            />
            {formErrors.currentPassword?.map(error => (
              <TwFormInputError key={error}>
                {Lang.tryLocalize(error)}
              </TwFormInputError>
            ))}
          </TwFormInputContainer>
        </TwFormRow>
      </TwForm>
    </Popup>
  )
})
